import Icon from '../../components/common/Icon/Icon';
import { useLanguage } from '../../context/LanguageContext';

const values = [
  ['leaf', 'Herbal Heritage', 'Respect for traditional Siddha and herbal wellness knowledge.'],
  ['drop', 'Quality and Purity', 'A consistent focus on quality, purity and responsible product presentation.'],
  ['message', 'Customer Care', 'Accessible support through phone, WhatsApp and professional email.']
];

function AboutPage() {
  const { translate } = useLanguage();
  return (
    <main className="content-page">
      <header className="content-page__hero"><div className="container"><p className="eyebrow">{translate('About Sanjeevi Grace Herbals')}</p><h1>{translate('Traditional Heritage, Presented with Care')}</h1><p>{translate('Sanjeevi Grace Herbals is dedicated to promoting natural wellness through traditional Siddha and herbal healthcare solutions.')}</p></div></header>
      <section className="section"><div className="container about-layout"><div className="about-layout__story"><h2>{translate('Reviving Health Naturally')}</h2><p>{translate("We combine time-tested knowledge with modern quality standards to make traditional herbal wellness more accessible to today's customers.")}</p><p>{translate('Our work is guided by a commitment to quality and purity while preserving the wisdom of our rich herbal heritage.')}</p></div><aside className="about-layout__values" aria-label={translate('Our values')}>{values.map(([icon, title, description]) => <div key={title}><span aria-hidden="true"><Icon name={icon} /></span><div><h3>{translate(title)}</h3><p>{translate(description)}</p></div></div>)}</aside></div></section>
    </main>
  );
}

export default AboutPage;
